import React, { useEffect, useState } from "react";
import { Button, Header, Image, Modal } from "semantic-ui-react";
import { LoadingSpinner } from "../Otros/LoadingSpinner";
import Swal from "sweetalert2";
import { CU17_detalleDerivacion, listarDocumentosDerivacion } from "../../utils/Datos";
import { fechaHumana } from "../../utils/Util";
import {BotonDocumento} from '../Otros/BotonDocumento';
import { RespuestasDerivaciones } from "./RespuestasDerivaciones";

export const ModalDetalle = ({ titulo, id_derivacion, onClick }) => {
  const [open, setOpen] = useState(false);
  const [derivacion, setDerivacion] = useState(null);

  const [listadoDocumentos, setlistadoDocumentos] = useState([]);

  useEffect(() => {
    
          listarDocumentosDerivacion(id_derivacion).then((respuesta)=>{
              if (respuesta.status) {
                  setlistadoDocumentos(respuesta.datos);
              }else{
              }
          })
      }
    
  , [id_derivacion])

  useEffect(() => {
    if (id_derivacion != null && id_derivacion != "") {
      CU17_detalleDerivacion(id_derivacion).then((resultado) => {
        if (resultado.status) {
          setDerivacion(resultado.datos);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              "Ha ocurrido un error al cargar esta derivación: " +
              resultado.errores[0],
          }).then((okay) => {});
        }
      });
    }
  }, [id_derivacion]);

  return (
    <Modal
      className="pb-2 pb-md-0"
      closeIcon
      open={open}
      trigger={
        <button className="btn btn-sm btn-success" onClick={() => onClick}>
          <strong><i className="fas fa-eye me-3"></i>Ver respuesta</strong>
        </button>
      }
      onClose={() => setOpen(false)}
      onOpen={() => {
        onClick();
        setOpen(true);
      }}
    >
      <Header icon="archive" content="Respuesta del Equipo Encargado" />
      {derivacion != null ? (
        <Modal.Content>
          <h4 className="border rounded text-center p-4 mb-4">{titulo}</h4>
          <h4>Resolución:</h4>
          <RespuestasDerivaciones id_derivacion={derivacion.id_derivation}></RespuestasDerivaciones>
          {
            /*
          <div
              className="border p-5"
             dangerouslySetInnerHTML={{__html: derivacion.comment_resolution}}
          
          >
         
          </div> */ }
          <div className="my-4">
            {listadoDocumentos.length>0 &&
            <>   
                <label className="form-label form-control-solid">Documentos de la resolución:</label>
                <div className='row'>
                    {
                        listadoDocumentos.map((documento,index)=>{
                          if (documento.is_resolution) {
                            return <div className='col-md-auto'>
                                <BotonDocumento 
                            key={`doc_${index}`}
                            documento={documento} ></BotonDocumento></div>
                          }
                            
                        })
                    }
                </div>
            </> }
          </div>
          
          <p className="fs-6 mb-4 pb-0">
            <h4>Resuelto por:</h4> {derivacion.resolution_team.name}
            {" el "}
            {fechaHumana(derivacion.date_resolution)}
          </p>
          <p className="fs-6">
            <h4>Entidad municipal:</h4>
            {derivacion.resolution_team.municipal_entity.name_municipal_entity}
          </p>
        </Modal.Content>
      ) : (
        <Modal.Content>
          <LoadingSpinner></LoadingSpinner>
        </Modal.Content>
      )}
      <Modal.Actions>
        <button onClick={() => setOpen(false)} className="btn btn-info">
          Cerrar
        </button>
      </Modal.Actions>
    </Modal>
  );
};
